// Libraries
import React from 'react';

// Supermove
import {gql} from '@supermove/graphql';

// App
import CautionModal from '@shared/design/components/Modal/SmallModal/CautionModal';

const SetAsPrimaryAccountModal = ({
  isOpen,
  handleClose,
  handleQuitEditing,
}: {
  isOpen: boolean;
  handleClose: () => void;
  handleQuitEditing: () => void;
}) => {
  return (
    <CautionModal
      isOpen={isOpen}
      handlePressOutside={handleClose}
      title={'Quit editing?'}
      message={'Your changes will not be saved.'}
      handlePrimaryAction={handleQuitEditing}
      primaryActionText={'Quit'}
      handleSecondaryAction={handleClose}
      secondaryActionText={'Cancel'}
    />
  );
};

// --------------------------------------------------
// Data
// --------------------------------------------------
SetAsPrimaryAccountModal.fragment = gql`
  fragment SetAsPrimaryAccountModal on AccountGrant {
    id
    isPrimary
  }
`;

export default SetAsPrimaryAccountModal;
